module.exports = __webpack_public_path__ + "static/media/r11.01ab2948.jpg";